import React from "react";
import { Card, FormGroup } from "@mui/material";

const LegalNotice = () => {
  return (
    <Card>
      <FormGroup>
      <h2>Legal Notice</h2>
      </FormGroup>
      <FormGroup>
        <p>Information in accordance with Section 5 TMG:</p>
      </FormGroup>
      <FormGroup>
      <p>Innomaze FlexCo<br />
      Schubertstraße 6a<br />
      8010 Graz, Austria</p>
    </FormGroup>
    <FormGroup>
<p>VAT number: ATU81398845</p>

<p>Registration number: FN 640899z</p>
</FormGroup>
<FormGroup>
<p>Represented by
Matthias Zelenka and Michael Maier</p>
</FormGroup>
<FormGroup>
<p>Contact Information
Email: office@lessonice.com</p></FormGroup>

<FormGroup>
  <p>Content attribution:</p>
  <p><a href="https://www.flaticon.com/free-icons/europe" title="europe icons">Europe icons created by GeekClick - Flaticon</a></p>
  <p><a href="https://www.flaticon.com/free-icons/austria" title="austria icons">Austria icons created by Freepik - Flaticon</a></p>
</FormGroup>

<FormGroup>
  <p className="text-secondary"><small>Online dispute resolution pursuant to Art. 14 (1) ODR Regulation: The European Commission provides a platform for online dispute resolution under http://ec.europa.eu/consumers/odr/
Disclaimer
Accountability for Content
The contents of our pages have been created with the utmost care. However, we cannot guarantee the contents' accuracy, completeness or topicality. According to statutory provisions, we are furthermore responsible for our own content on these web pages. In this matter, please note that we are not obliged to monitor the transmitted or saved information of third parties, or investigate circumstances pointing to illegal activity. Our obligations to remove or block the use of information under generally applicable laws remain unaffected by this as per §§ 8 to 10 of the Telemedia Act (TMG).
Accountability for Links
Responsibility for the content of external links (to web pages of third parties) lies solely with the operators of the linked pages. No violations were evident to us at the time of linking. Should any legal infringement become known to us, we will remove the respective link immediately.
Copyright
Our web pages and their contents are subject to Austrian copyright law. Unless expressly permitted by law, every form of utilizing, reproducing or processing works subject to copyright protection on our web pages requires the prior consent of the respective owner of the rights. Individual reproductions of a work are only allowed for private use. The materials from these pages are copyrighted and any unauthorized use may violate copyright laws.
    </small></p></FormGroup></Card>
  );
};

export default LegalNotice;
